import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  SvgIcon,
  Fab
} from '@mui/material';
import jsPDF from 'jspdf';
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  MoreVert as MoreVertIcon,
  Visibility as ViewIcon,
  Schedule as ScheduleIcon,
  Delete as DeleteIcon,
  Close as CloseIcon,
  Download as DownloadIcon,
  InsertDriveFile as FileIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
  Archive as ArchiveIcon,
  CloudUpload as UploadIcon,
  AttachFile as AttachIcon,
  TrendingUp as TrendingUpIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  AddCircle as AddCircleIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';
import { Add as AddIcon } from '@mui/icons-material';
import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import ApiService from '../../../../services/api';

import PaymentsService from '../../../../services/PaymentsService';
import SharedPlanChip from '../../../PlanChip';
import LocalCitationIcon from '../../../icons/LocalCitationIcon';

import logger from '../../../../utils/logger';
import { formatDate, formatTime } from '../../../../utils/dateUtils';
import { useAdminData } from '../../../../contexts/AdminDataContext';
// Mock data for a single client - in a real app, you'd fetch this by ID
const mockClient = {
  id: 1,
  businessName: 'Krishna Properties',
  businessCategory: 'Real estate agent - E2E Group',
  profileStatus: 'Active',
  contact: '08666 23322',
  whatsapp: '08666 23322',
  plan: 'pro',
  address: 'Office Floor, Bestech, Sector 66, Sahibzada Ajit Singh Nagar, Punjab 160066',
  leadSource: 'Offline',
  familyAccount: 2,
  cro: 'Neon Dip',
  bdm: 'Scott Dip',
  welcomeCall: 'No',
  isConnected: false
};

// Mock data for payments
// Mock data for payments
const mockPayments = [];


// Mock data removed as real data is now integrated


// Mock data for attachments
const mockAttachments = [
  { id: 1, fileName: 'Business_License.pdf', fileType: 'PDF', fileSize: '1.2 MB', uploadedDate: '2023-10-15', uploadedBy: 'Admin', description: 'Business registration document' },
  { id: 2, fileName: 'Store_Front.jpg', fileType: 'JPG', fileSize: '2.5 MB', uploadedDate: '2023-10-16', uploadedBy: 'Scott Scott', description: 'Store front photo for GMB' },
  { id: 3, fileName: 'Tax_Documents.zip', fileType: 'ZIP', fileSize: '5.0 MB', uploadedDate: '2023-10-17', uploadedBy: 'Admin', description: 'Annual tax filing records' }
];
// Mock data for local citations
const mockCitations = [];

const ProfileContainer = styled(Box)(({ theme }) => ({
  padding: '24px',
  backgroundColor: '#f5f7fa',
  minHeight: '100vh',
}));

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px',
  flexWrap: 'wrap',
  gap: '16px',
}));

const TitleSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

const TitleIcon = styled(Box)(({ theme }) => ({
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
}));

const ProfileCard = styled(Paper)(({ theme }) => ({
  padding: '24px',
  borderRadius: '16px',
  background: '#fff',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  marginBottom: '24px',
}));

const DetailsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '24px',
}));

const DetailItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '8px 0',
  borderBottom: '1px solid #f0f0f0',
  '&:last-child': {
    borderBottom: 'none',
  },
}));

const DetailLabel = styled(Typography)(({ theme }) => ({
  width: '180px',
  fontWeight: 600,
  color: '#64748b',
  fontSize: '14px',
}));

const DetailValue = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: '#1f2937',
  fontSize: '14px',
  flex: 1,
}));

const TicketsTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  overflow: 'hidden',
  marginTop: '24px',
}));

const Th = styled(TableCell)(({ theme }) => ({
  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  color: '#ffffff',
  fontWeight: 600,
  padding: '16px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
}));

const Td = styled(TableCell)(({ theme }) => ({
  padding: '14px 16px',
  borderBottom: '1px solid #f0f0f0',
  fontSize: '14px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#eff6ff',
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  padding: '4px',
  minHeight: 'auto',
  '& .MuiTab-root': {
    minHeight: '44px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    color: '#64748b',
    transition: 'all 0.2s ease',
    '&.Mui-selected': {
      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      color: '#fff',
    },
    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.1)',
    },
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

const PLAN_AMOUNT_MATRIX = {
  basic: { monthly: 1199, annually: 11999 },
  advanced: { monthly: 1999, annually: 19999 },
  pro: { monthly: 2999, annually: 29999 }
};

const PLAN_DISPLAY_NAMES = {
  basic: 'Basic',
  advanced: 'Advanced',
  pro: 'Pro'
};

const PLAN_TYPE_LABELS = {
  one_shot: 'One Shot (Yearly)',
  emi: 'EMI (Monthly)'
};

const PLAN_SELECT_OPTIONS = [
  { value: 'basic', label: 'Basic' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'pro', label: 'Pro' }
];

const normalizePlanKey = (value) => {
  if (!value) return '';
  const normalized = String(value).toLowerCase().trim();
  if (normalized === 'advance') return 'advanced';
  if (['starter', 'starter_plan'].includes(normalized)) return 'basic';
  if (['premium', 'business'].includes(normalized)) return 'pro';
  if (PLAN_AMOUNT_MATRIX[normalized]) return normalized;
  return normalized;
};

const getAmountForPlan = (plan, type) => {
  if (!plan || !type) return null;
  const normalizedPlan = normalizePlanKey(plan);
  const planConfig = PLAN_AMOUNT_MATRIX[normalizedPlan];
  if (!planConfig) return null;
  const bucket = type === 'emi' ? 'monthly' : 'annually';
  return planConfig[bucket] || null;
};

const getPlanLabel = (plan) => {
  if (!plan) return '';
  return PLAN_DISPLAY_NAMES[plan] || plan;
};

const ClientProfile = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const { clients, meetings: cachedMeetings, employees, actions } = useAdminData();
  const [client, setClient] = useState(null);
  const [tabIndex, setTabIndex] = useState(1);
  const [meetings, setMeetings] = useState([]);
  const [loadingMeetings, setLoadingMeetings] = useState(false);
  const [attachmentMenuAnchor, setAttachmentMenuAnchor] = useState(null);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [attachmentViewOpen, setAttachmentViewOpen] = useState(false);
  const [attachmentUploadOpen, setAttachmentUploadOpen] = useState(false);
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [addMeetingOpen, setAddMeetingOpen] = useState(false);
  const [newMeeting, setNewMeeting] = useState({ title: '', date: '', time: '', description: '', department: '' });
  const [lead, setLead] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [citations, setCitations] = useState([]);
  const [savingCitations, setSavingCitations] = useState(false);

  // Management Edit State
  const [editMgmtOpen, setEditMgmtOpen] = useState(false);
  const [editMgmtData, setEditMgmtData] = useState({
    leadSource: '',
    croId: '',
    bdmId: ''
  });
  const [updatingMgmt, setUpdatingMgmt] = useState(false);
  const [activities, setActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(false);

  // Payment Management State
  const [editPaymentOpen, setEditPaymentOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({
    payment_amount: '',
    payment_date: '',
    payment_status: 'pending',
    payment_method: '',
    payment_reference: '',
    payment_type: 'one_shot',
    package: ''
  });
  const [updatingPayment, setUpdatingPayment] = useState(false);
  const [paymentsHistory, setPaymentsHistory] = useState([]);
  const [loadingPaymentsHistory, setLoadingPaymentsHistory] = useState(false);
  const [planDetails, setPlanDetails] = useState({ start: null, end: null, renewSoon: false, daysRemaining: 0 });

  const handleViewPaymentAttachments = (paymentId) => {
    // Navigate to the PaymentProfile page
    navigate(`/admin-dashboard/payment-profile/${paymentId}`);
  };



  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const normalizeId = (id) => String(id || '').replace('locations/', '');
        const targetId = normalizeId(clientId);

        // Try to find in cache first
        let match = clients?.find(a => normalizeId(a.location_id) === targetId || normalizeId(a.id) === targetId);

        // If not in cache or cache empty, fetch or wait for background fetch
        if (!match) {
          const freshClients = await actions.fetchClients();
          match = freshClients?.find(a => normalizeId(a.location_id) === targetId || normalizeId(a.id) === targetId);
        }

        if (!match) {
          logger.warn(`[ClientProfile] GMB Account not found for clientId: ${clientId}`);
          setClient(mockClient);
          return;
        }

        // We already have the normalized vm-like structure in the context's 'clients'
        // But the context structure is slightly different (it already did the normalization)
        // Let's ensure consistency. In AdminDataContext.jsx, we merged data.
        // Let's re-normalize based on what match actually is.

        const locationData = typeof match.location_data === 'string'
          ? (() => { try { return JSON.parse(match.location_data); } catch (e) { return {}; } })()
          : (match.location_data || match.locationData || {});

        logger.log('[ClientProfile] Debug Category:', {
          matchCategory: match.category,
          dbCategory: match.businessCategory,
          gmbCategory: locationData?.primaryCategory?.displayName,
          rawCategory: match.raw?.category,
          locationData: locationData
        });

        const vm = {
          id: match.id,
          locationId: match.location_id || match.locationId || match.id,
          businessName: match.business_name || match.businessName || (locationData?.title || locationData?.name) || '—',
          businessCategory: locationData?.primaryCategory?.displayName ||
            locationData?.category?.displayName ||
            locationData?.category ||
            match.category ||
            match.business_category ||
            match.businessCategory ||
            match.raw?.category ||
            match.raw?.business_category ||
            '—',
          profileStatus: (match.is_verified || match.profileStatus === 'Active') ? 'Active' : 'Pending',
          contact: match.phone_number || match.phone || match.contact || '—',
          whatsapp: match.whatsapp || match.phone_number || match.phone || '—',
          plan: match.plan || match.package || null,
          address: (() => {
            if (match.address && match.address !== '—') return match.address;

            // Check raw address from GMB
            if (match.raw?.address) return match.raw.address;

            // Check standalone lead/client address fields
            const leadAddr = [
              match.address_line1,
              match.address_line2,
              match.city,
              match.state,
              match.zip_code || match.zipCode
            ].filter(Boolean).join(', ');
            if (leadAddr) return leadAddr;

            const addr = locationData?.storefrontAddress || locationData?.address || {};
            if (addr.formattedAddress) return addr.formattedAddress;

            // Construct from components
            const parts = [
              Array.isArray(addr.addressLines) ? addr.addressLines.join(', ') : addr.addressLines,
              addr.locality || locationData?.city || match.city,
              addr.administrativeArea || locationData?.state || match.state,
              addr.postalCode || locationData?.postalCode || match.zip_code || match.zipCode
            ].filter(Boolean);

            return parts.length > 0 ? parts.join(', ') : '—';
          })(),
          leadSource: match.lead_source || match.leadSource || 'GMB Sync',
          familyAccount: match.family_account || match.familyAccount || 0,
          bdm: match.bdm_name || match.bdm || match.user?.full_name || '—',
          welcomeCall: (match.welcome_call || match.welcomeCall) ? 'Yes' : 'No',
          userId: match.raw?.user_id || match.userId || match.raw?.user?.id || (match.raw?.owner_id),
          isConnected: true,
          lead_uid: match.lead_uid || null,  // ESC Client ID from AdminDataContext
          lead: match.lead || null,  // Full lead record from AdminDataContext
          email: match.email || match.contact_email || match.user?.email || match.raw?.email || '—',
          website: match.website || locationData?.websiteUri || null
        };

        setClient(vm);

        setCitations([{
          directory: '',
          businessName: '',
          address: '',
          phone: ''
        }]);

        // If we have lead data from the cached client, set it immediately
        if (match.lead) {
          setLead(match.lead);
        }

        // Use cached meetings if available
        setLoadingMeetings(true);
        try {
          const allMs = cachedMeetings || await actions.fetchMeetings();

          const filtered = allMs.filter(m => {
            const biz = (m.client || '').toLowerCase();
            const contact = (m.contact_number || '').toLowerCase();
            const targetBiz = (vm.businessName || '').toLowerCase();
            const targetContact = (vm.contact || '').toLowerCase();
            return (targetBiz && biz.includes(targetBiz)) || (targetContact && contact.includes(targetContact));
          });
          setMeetings(filtered);
        } catch (mErr) {
          logger.error('[ClientProfile] Meetings error:', mErr);
        } finally {
          setLoadingMeetings(false);
        }
      } catch (e) {
        logger.error('Failed to load GMB client profile:', e);
        setClient(mockClient);
      }
    };
    if (clientId) fetchClientData();
  }, [clientId, actions]); // Added actions to dependency

  // Fetch Lead Data separately when client is loaded
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!client?.userId && !client?.email && !client?.contact) return;

      try {
        // We use ensure-lead to find or create the lead safely
        const payload = {
          user_id: client.userId,
          first_name: client.businessName, // Using business name as fallback name
          email: client.email || undefined,
          phone_number: client.contact || undefined,
          lead_source: 'Client Profile',
          type: 'client'
        };

        // FIXED: Endpoint should be /leads/ (plural) to match backend route mount
        const response = await ApiService.post('/admin/leads/ensure-lead', payload);
        if (response?.data?.lead) {
          setLead(response.data.lead);
          logger.log('[ClientProfile] Lead data fetched:', response.data.lead);
        }
      } catch (err) {
        logger.error('[ClientProfile] Failed to fetch/ensure lead:', err);
      }
    };

    if (client) {
      fetchLeadData();
    }
  }, [client]);

  // Refresh meetings when lead is available (filtering by lead_id)
  useEffect(() => {
    // If we have lead.id, use it. If not, and we have client.userId, use that.
    // If neither, wait.
    if (!lead?.id && !client?.userId) return;

    const refreshMeetings = async () => {
      setLoadingMeetings(true);
      try {
        // Fetch directly using the specific filter
        const queryParams = new URLSearchParams();
        if (lead?.id) queryParams.append('lead_id', lead.id);
        else if (client?.userId) queryParams.append('client_id', client.userId);

        queryParams.append('pageSize', '100');

        // FIXED: ApiService.get(url, headers) - params must be in URL string, not 2nd arg
        const queryString = queryParams.toString();
        const response = await ApiService.get(`/admin/meeting/get-meeting?${queryString}`);

        // Response might be { data: { meetings: [] } } or similar structure handled by interceptor? 
        // Looking at AdminDataContext: const root = resp?.data ?? resp; const meetings = ...

        const root = response?.data ?? response;
        const fetchedMeetings = Array.isArray(root) ? root : (root?.meetings || root?.data?.meetings || root?.data || []);

        setMeetings(fetchedMeetings);
      } catch (e) {
        logger.error('[ClientProfile] Error refreshing meetings with lead ID:', e);
        setMeetings([]);
      } finally {
        setLoadingMeetings(false);
      }
    };

    refreshMeetings();
  }, [lead, client, refreshTrigger]);

  const fetchActivities = async () => {
    if (!lead?.id) return;

    setLoadingActivities(true);
    try {
      const response = await ApiService.get(`/admin/leads/get-lead-activities/${lead.id}`);
      const fetchedActivities = response?.data || [];
      setActivities(fetchedActivities);
    } catch (error) {
      logger.error('[ClientProfile] Failed to fetch activities:', error);
    } finally {
      setLoadingActivities(false);
    }
  };

  // Fetch Activities when refreshTrigger changes or when tab is active
  useEffect(() => {
    if (lead?.id && (tabIndex === 2 || refreshTrigger > 0)) {
      fetchActivities();
    }
  }, [lead, tabIndex, refreshTrigger]);

  // Fetch Payment History
  useEffect(() => {
    const fetchHistory = async () => {
      if (!client?.userId) return;
      setLoadingPaymentsHistory(true);
      try {
        const res = await PaymentsService.fetchPayments({ userId: client.userId });
        const data = res?.data?.payments || res?.data || [];
        const validPayments = Array.isArray(data) ? data : [];

        // Filter: Status must be captured/paid AND strictly belong to this user
        const filteredPayments = validPayments.filter(p => {
          // specific status check
          const isPaid = (p.status === 'captured' || p.status === 'paid' || p.payment_status === 'paid');
          // sanity check for user_id to avoid data leakage if API returns mixed data
          const isCorrectUser = p.user_id ? (String(p.user_id) === String(client.userId)) : true;
          return isPaid && isCorrectUser;
        });

        // Sort by date desc
        filteredPayments.sort((a, b) => new Date(b.created_at || b.createdAt || b.payment_date) - new Date(a.created_at || a.createdAt || a.payment_date));
        setPaymentsHistory(filteredPayments);

        // Calculate Plan Dates based on latest successful payment
        const latestPaid = validPayments.find(p => p.status === 'paid' || p.payment_status === 'paid');
        // If no paid payment in history, fallback to lead data if status is paid
        const refPayment = latestPaid || (lead?.payment_status === 'paid' ? lead : null);

        if (refPayment) {
          const pDate = refPayment.payment_date || refPayment.created_at || refPayment.createdAt;
          if (pDate) {
            const start = new Date(pDate);
            const isMonthly = (refPayment.payment_type === 'emi' || refPayment.type === 'emi' || (client.plan && client.plan.includes('monthly')));

            const end = new Date(start);
            if (isMonthly) {
              end.setMonth(end.getMonth() + 1);
            } else {
              end.setFullYear(end.getFullYear() + 1);
            }

            const now = new Date();
            const diffTime = end - now;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            setPlanDetails({
              start: start,
              end: end,
              renewSoon: diffDays <= 7 && diffDays >= 0, // alert if within 7 days
              daysRemaining: diffDays,
              isOverdue: diffDays < 0
            });
          }
        }
      } catch (err) {
        logger.error('[ClientProfile] Failed to fetch payment history:', err);
      } finally {
        setLoadingPaymentsHistory(false);
      }
    };

    if (client?.userId) {
      fetchHistory();
    }
  }, [client?.userId, lead]);

  const completionPercentage = useMemo(() => {
    if (!client) return 0;
    const fields = [
      'businessName',
      'businessCategory',
      'contact',
      'whatsapp',
      'address',
      'plan',
      'bdm',
      'leadSource'
    ];
    let filled = 0;
    fields.forEach(f => {
      const v = client[f];
      if (v && v !== '—' && v !== 'None' && v !== 0 && v !== '' && v !== 'N/A') filled++;
    });
    if (client.welcomeCall === 'Yes') filled++;
    return Math.round((filled / (fields.length + 1)) * 100);
  }, [client]);

  const handleTabChange = (event, newValue) => {
    logger.log('Tab changed to:', newValue);
    logger.log('Mock payments data length:', mockPayments.length);
    setTabIndex(newValue);
  };

  const handleAttachmentMenuClick = (event, attachment) => {
    setAttachmentMenuAnchor(event.currentTarget);
    setSelectedAttachment(attachment);
  };

  const handleAttachmentMenuClose = () => {
    setAttachmentMenuAnchor(null);
    setSelectedAttachment(null);
  };

  const handleAttachmentViewOpen = (attachment) => {
    setSelectedAttachment(attachment);
    setAttachmentViewOpen(true);
    handleAttachmentMenuClose();
  };

  const handleGoToGmbProfile = async () => {
    try {
      logger.log('dYs? [ClientProfile] Navigating to GMB profile for client:', clientId);

      const realUserId = client?.userId;
      if (!realUserId) {
        alert('User ID not found for this client. Cannot navigate to GMB profile.');
        return;
      }

      const clientDetails = await ApiService.get(`/admin/users/get-user/${realUserId}`);
      const gmbAccounts = clientDetails?.data?.gmb_accounts || [];
      const clientData = clientDetails?.data?.user || {};

      // ALLOW ACCESS EVEN IF NO GMB ACCOUNTS
      // if (gmbAccounts.length === 0) {
      //   alert('This client has no GMB accounts connected yet.');
      //   return;
      // }

      logger.log(`-> [ClientProfile] Found ${gmbAccounts.length} GMB accounts for client`);

      const googleAccessToken = clientData.google_access_token;
      if (googleAccessToken) {
        logger.log('dY" [ClientProfile] Client has Google access token');
      } else {
        logger.warn('[ClientProfile] Client has no Google access token stored');
      }

      let defaultProfileData = null;
      if (gmbAccounts.length > 0) {
        const firstAccount = gmbAccounts[0];
        const locationData = typeof firstAccount.location_data === 'string'
          ? JSON.parse(firstAccount.location_data)
          : firstAccount.location_data;

        defaultProfileData = {
          id: firstAccount.location_id,
          locationId: firstAccount.location_id,
          accountId: firstAccount.account_id || null, // Ensure accountId is passed
          name: firstAccount.business_name || (locationData?.title || locationData?.name),
          locationData: locationData
        };

        logger.log('dYZ_ [ClientProfile] Prepared default profile:', defaultProfileData.name);
      } else {
        // Fallback if no GMB accounts - create a dummy profile state to allow dashboard access
        logger.log('dYZ_ [ClientProfile] No GMB accounts - creating fallback profile state');
        defaultProfileData = {
          id: 'stub_' + realUserId,
          locationId: 'stub_' + realUserId,
          name: clientData.full_name || client.businessName || 'Client Dashboard',
          isStub: true
        };
      }

      const adminAccessData = {
        isAdminAccess: true,
        originalAdminId: localStorage.getItem('userId'),
        targetUserId: clientData.id,
        targetUserEmail: clientData.email,
        targetUserName: clientData.full_name || clientData.name,
        gmbAccounts: gmbAccounts,
        googleAccessToken: googleAccessToken,
        defaultProfile: defaultProfileData,
        timestamp: Date.now()
      };

      const tempKey = `admin_viewing_gmb_${defaultProfileData.locationId || 'stub'}_${Date.now()}`;
      const serializedAccess = JSON.stringify(adminAccessData);

      sessionStorage.setItem(tempKey, serializedAccess);
      sessionStorage.setItem('adminAccessData', serializedAccess);
      sessionStorage.setItem('adminViewingGmbTempKey', tempKey);

      try {
        localStorage.setItem(tempKey, serializedAccess);
        localStorage.setItem('latestAdminAccessTempKey', tempKey);
      } catch (storageError) {
        logger.warn('[ClientProfile] Unable to mirror admin access payload to localStorage:', storageError);
      }

      // If we have a real location, use it. If not, don't pass locationId param so dashboard picks default or shows empty
      const locParam = (!defaultProfileData.isStub && defaultProfileData.locationId) ? `&locationId=${defaultProfileData.locationId}` : '';
      const dashboardUrl = `/dashboard?adminAccess=true&tempKey=${tempKey}&userId=${adminAccessData.targetUserId}${locParam}`;
      window.open(dashboardUrl, '_blank');

      logger.log('[ClientProfile] Opened GMB profile in new tab');
    } catch (err) {
      logger.error('[ClientProfile] Error navigating to GMB profile:', err);
      alert('Failed to access client profile. Please try again.');
    }
  };
  const handleAttachmentViewClose = () => {
    setAttachmentViewOpen(false);
    setSelectedAttachment(null);
  };

  const handleAttachmentUploadOpen = () => {
    logger.log('Add Attachment button clicked - opening upload modal');
    setAttachmentUploadOpen(true);
  };

  const handleAttachmentUploadClose = () => {
    setAttachmentUploadOpen(false);
  };

  const handleScheduleAttachmentOpen = (attachment) => {
    setSelectedAttachment(attachment);
    setScheduleDialogOpen(true);
  };

  const handleScheduleAttachmentClose = () => {
    setScheduleDialogOpen(false);
    setSelectedAttachment(null);
  };

  const handleNewMeetingChange = (key) => (e) => {
    setNewMeeting((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleAddMeetingReset = () => setNewMeeting({ title: '', date: '', time: '', description: '', department: '' });

  const handleAddMeetingSubmit = async () => {
    logger.log('Create meeting:', newMeeting);

    try {
      if (!lead?.id) {
        alert('Cannot schedule meeting: Lead record not found for this client.');
        return;
      }

      const bdmId = lead.bdm_employee_id || lead.employee_id;
      if (!bdmId) {
        // Fallback: If no BDM assigned, maybe confirm? 
        // For now, we'll proceed but backend might require employee_id.
        // We'll try to use the current admin ID or just pass null and see if backend handles it (it says required)
        // Let's use the lead.employee_id if bdm is null.
        alert('Warning: No BDM or Employee assigned to this client lead. Please assign one first.');
        return;
      }

      const payload = {
        lead_id: lead.id,
        client_id: client.userId || lead.user_id, // Ensure we have a valid client_id
        employee_id: bdmId, // This assigns it to the BDM
        title: newMeeting.title,
        meeting_date: newMeeting.date,
        date_time: `${newMeeting.date} ${newMeeting.time || '00:00'}`,
        // We can map department to tags or type
        type: newMeeting.department,
        comment: newMeeting.description,
        status: 'scheduled',
        // Optional fields
        meeting_with: client.userId,
        presentation_show: false
      };

      await ApiService.post('/admin/meeting/create-meeting', payload);

      setRefreshTrigger(prev => prev + 1);

      setAddMeetingOpen(false);
      handleAddMeetingReset();
      alert('Meeting scheduled successfully!');

    } catch (error) {
      logger.error('Failed to create meeting:', error);
      alert('Failed to schedule meeting: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleCitationChange = (index, field, value) => {
    const updated = [...citations];
    updated[index] = { ...updated[index], [field]: value };
    setCitations(updated);
  };

  const handleAddCitationRow = () => {
    setCitations([...citations, {
      directory: '',
      businessName: '',
      address: '',
      phone: ''
    }]);
  };

  const handleRemoveCitationRow = (index) => {
    const updated = citations.filter((_, i) => i !== index);
    setCitations(updated);
  };

  const handleSaveCitationRow = async (index) => {
    const row = citations[index];
    if (!row.directory) {
      alert('Please enter a directory name');
      return;
    }

    setSavingCitations(true);
    try {
      logger.log('Saving Citation Row:', row);
      await new Promise(resolve => setTimeout(resolve, 800));
      alert(`${row.directory} saved successfully!`);
    } catch (error) {
      logger.error('Failed to save citation row:', error);
      alert('Failed to save citation row');
    } finally {
      setSavingCitations(false);
    }
  };

  const handleSaveCitations = async () => {
    setSavingCitations(true);
    try {
      // For now this is mock as there's no backend endpoint yet
      logger.log('Saving Citations:', citations);
      await new Promise(resolve => setTimeout(resolve, 1000));
      alert('Citations updated successfully!');
    } catch (error) {
      logger.error('Failed to save citations:', error);
      alert('Failed to save citations');
    } finally {
      setSavingCitations(false);
    }
  };

  const [updatingWelcomeCall, setUpdatingWelcomeCall] = useState(false);

  const handleWelcomeCallComplete = async () => {
    if (!lead?.id) {
      alert('Lead record not found. Please wait for sync or try refreshing.');
      return;
    }

    setUpdatingWelcomeCall(true);
    try {
      // Prepare payload - send ONLY partial update
      const payload = {
        welcome_call: true,
        current_user: { id: localStorage.getItem('userId') }
      };

      await ApiService.put(`/admin/leads/update-leads/${lead.id}`, payload);

      // Update local state
      setLead(prev => ({ ...prev, welcome_call: true }));
      setClient(prev => ({ ...prev, welcomeCall: 'Yes' }));

      // Trigger global refresh to ensure persistence in list views
      if (actions.fetchClients) actions.fetchClients(true);

      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      logger.error('Failed to update welcome call status:', error);
      alert('Failed to update status: ' + (error.message || 'Unknown error'));
    } finally {
      setUpdatingWelcomeCall(false);
    }
  };

  const handleEditMgmtOpen = () => {
    if (!lead) {
      alert('Please wait for lead data to load.');
      return;
    }
    // Fetch employees if not available
    if (!employees) {
      actions.fetchEmployees();
    }
    setEditMgmtData({
      leadSource: lead.lead_source || client.leadSource || '',
      tellyId: lead.telly_employee_id || '',
      bdmId: lead.bdm_employee_id || ''
    });
    setEditMgmtOpen(true);
  };

  const handleEditMgmtSubmit = async () => {
    if (!lead?.id) return;
    setUpdatingMgmt(true);

    try {
      // Find names for selected IDs to keep string fields in sync
      const selectedTelly = employees?.find(e => e.id === editMgmtData.tellyId);
      const selectedBdm = employees?.find(e => e.id === editMgmtData.bdmId);

      const payload = {
        lead_source: editMgmtData.leadSource,
        telly_employee_id: editMgmtData.tellyId || null,
        cro_name: selectedTelly ? `${selectedTelly.first_name} ${selectedTelly.last_name}` : lead.cro_name,
        bdm_employee_id: editMgmtData.bdmId || null,
        bdm_name: selectedBdm ? `${selectedBdm.first_name} ${selectedBdm.last_name}` : lead.bdm_name,
        employee_id: editMgmtData.bdmId || lead.employee_id,
        current_user: { id: localStorage.getItem('userId') }
      };

      await ApiService.put(`/admin/leads/update-leads/${lead.id}`, payload);

      // Update local state
      setLead(prev => ({ ...prev, ...payload }));
      setClient(prev => ({
        ...prev,
        leadSource: payload.lead_source,
        cro: payload.cro_name,
        bdm: payload.bdm_name
      }));

      if (actions.fetchClients) actions.fetchClients(true);

      setEditMgmtOpen(false);
      alert('Management details updated successfully!');
    } catch (err) {
      logger.error('Failed to update management details:', err);
      alert('Failed to update: ' + err.message);
    } finally {
      setUpdatingMgmt(false);
    }
  };

  // Payment Management Handlers
  const handleOpenPaymentEdit = () => {
    if (lead) {
      const normalizedPlan = normalizePlanKey(lead.package || client?.plan);
      const initialType = lead.payment_type || 'one_shot';
      const existingAmount = typeof lead.payment_amount !== 'undefined' && lead.payment_amount !== null
        ? String(lead.payment_amount)
        : '';
      const planAutoAmount = getAmountForPlan(normalizedPlan, initialType);
      const initialAmount = existingAmount || (planAutoAmount ? String(planAutoAmount) : '');
      setPaymentData({
        payment_amount: initialAmount,
        payment_date: lead.payment_date ? new Date(lead.payment_date).toISOString().split('T')[0] : '',
        payment_status: lead.payment_status || 'pending',
        payment_method: lead.payment_method || '',
        payment_reference: lead.payment_reference || '',
        payment_type: initialType,
        package: normalizedPlan
      });
    }
    setEditPaymentOpen(true);
  };

  const handlePaymentFormChange = (e) => {
    const { name, value } = e.target;
    setPaymentData(prev => {
      const next = { ...prev, [name]: value };
      if (name === 'package' || name === 'payment_type') {
        const planKey = name === 'package' ? value : prev.package;
        const typeKey = name === 'payment_type' ? value : prev.payment_type;
        const autoAmount = getAmountForPlan(planKey, typeKey);
        if (autoAmount) {
          next.payment_amount = String(autoAmount);
        }
      }
      return next;
    });
  };

  const handlePaymentSubmit = async () => {
    if (!lead?.id) return;

    setUpdatingPayment(true);
    try {
      const payload = {
        ...paymentData,
        current_user: { id: localStorage.getItem('userId') }
      };

      await ApiService.put(`/admin/leads/update-leads/${lead.id}`, payload);

      // Update local state
      setLead(prev => ({ ...prev, ...paymentData }));
      if (paymentData.package) {
        setClient(prev => (prev ? { ...prev, plan: paymentData.package } : prev));
      }

      if (actions.fetchClients) actions.fetchClients(true);

      setEditPaymentOpen(false);
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      logger.error('Failed to update payment details:', err);
      alert('Failed to update payment: ' + err.message);
    } finally {
      setUpdatingPayment(false);
    }
  };

  const handleAttachmentAction = (action, attachment) => {
    logger.log(`${action} clicked for attachment:`, attachment.fileName);
    // Handle the action based on what was clicked
    switch (action) {
      case 'view':
        handleAttachmentViewOpen(attachment);
        break;
      case 'download':
        logger.log('Downloading attachment:', attachment.fileName);
        // In a real app, you would trigger the download here
        // window.open(attachment.downloadUrl, '_blank');
        break;
      case 'schedule':
        handleScheduleAttachmentOpen(attachment);
        break;
      case 'delete':
        // Handle delete action
        break;
      default:
        break;
    }
    handleAttachmentMenuClose();
  };

  const selectedPlanAmount = getAmountForPlan(paymentData.package, paymentData.payment_type);
  const planLabel = getPlanLabel(paymentData.package);
  const scheduleLabel = PLAN_TYPE_LABELS[paymentData.payment_type] || 'payment schedule';
  const planAutoText = paymentData.package
    ? `${planLabel} + ${scheduleLabel}${selectedPlanAmount ? ` defaults to ₹${selectedPlanAmount.toLocaleString('en-IN')}` : ''}.`
    : 'Select a plan and payment schedule to autofill the amount.';

  const handleDownloadReport = () => {
    if (!client) return;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Colors
    const primaryColor = [59, 130, 246]; // #3b82f6
    const secondaryColor = [100, 116, 139]; // #64748b
    const darkColor = [31, 41, 55]; // #1f2937

    let yPos = 20;

    // Header
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 15, 'F');

    doc.setFontSize(22);
    doc.setTextColor(255, 255, 255);
    doc.text('Visibeen', 15, 10);
    doc.setFontSize(10);
    doc.text('Professional Client Report', pageWidth - 15, 10, { align: 'right' });

    // Title
    yPos += 15;
    doc.setTextColor(...darkColor);
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text(`Client Profile: ${client.businessName}`, 15, yPos);

    yPos += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...secondaryColor);
    doc.text(`Report Generated On: ${formatDate(new Date())}`, 15, yPos);
    doc.text(`Client ID: ${lead?.lead_uid || client.lead_uid || 'N/A'}`, pageWidth - 15, yPos, { align: 'right' });

    const drawDivider = (y) => {
      doc.setDrawColor(226, 232, 240);
      doc.line(15, y, pageWidth - 15, y);
    }

    const checkPageBreak = (spaceNeeded) => {
      if (yPos + spaceNeeded > pageHeight - 20) {
        doc.addPage();
        yPos = 20;
        return true;
      }
      return false;
    }

    // Section: Business Info
    yPos += 15;
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.setFont('helvetica', 'bold');
    doc.text('Business Information', 15, yPos);
    yPos += 5;
    drawDivider(yPos);
    yPos += 10;

    doc.setFontSize(11);
    doc.setTextColor(...darkColor);
    doc.setFont('helvetica', 'bold');

    const renderField = (label, value) => {
      if (checkPageBreak(10)) yPos += 10;
      doc.setFont('helvetica', 'bold');
      doc.text(`${label}:`, 15, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(String(value || '-'), 60, yPos);
      yPos += 7;
    }

    renderField('Category', client.businessCategory);
    renderField('Contact', client.contact);
    renderField('WhatsApp', client.whatsapp);
    renderField('Email', lead?.email || client.email || '-');
    renderField('Address', client.address);
    renderField('Plan', client.plan ? client.plan.toUpperCase() : 'NO PLAN');

    // Section: Management Info
    yPos += 10;
    checkPageBreak(30);
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.setFont('helvetica', 'bold');
    doc.text('Management Details', 15, yPos);
    yPos += 5;
    drawDivider(yPos);
    yPos += 10;

    doc.setFontSize(11);
    doc.setTextColor(...darkColor);

    renderField('Lead Source', lead?.lead_source || client.leadSource);
    renderField('BDM', lead?.bdm_name || client.bdm);
    renderField('CRO', lead?.cro_name || client.cro);
    renderField('Welcome Call', (lead?.welcome_call || client.welcomeCall === 'Yes') ? 'Completed' : 'Pending');
    renderField('Profile Score', `${completionPercentage}%`);

    // Section: Plan & Renewal
    if (planDetails.start) {
      yPos += 10;
      checkPageBreak(30);
      doc.setFontSize(14);
      doc.setTextColor(...primaryColor);
      doc.setFont('helvetica', 'bold');
      doc.text('Plan & Renewal', 15, yPos);
      yPos += 5;
      drawDivider(yPos);
      yPos += 10;

      doc.setFontSize(11);
      doc.setTextColor(...darkColor);
      renderField('Plan Started', formatDate(planDetails.start));
      renderField('Renews On', formatDate(planDetails.end));
      renderField('Days Remaining', `${planDetails.daysRemaining} days`);
      renderField('Status', planDetails.isOverdue ? 'Overdue' : planDetails.renewSoon ? 'Renew Soon' : 'Active');
    }

    // Payment History Table
    yPos += 15;
    checkPageBreak(50);
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment History', 15, yPos);
    yPos += 8;

    // Simple Table Header
    doc.setFillColor(248, 250, 252);
    doc.rect(15, yPos, pageWidth - 30, 10, 'F');
    doc.setFontSize(10);
    doc.setTextColor(...darkColor);
    doc.text('Date', 20, yPos + 6);
    doc.text('Amount', 60, yPos + 6);
    doc.text('Status', 90, yPos + 6);
    doc.text('Plan', 130, yPos + 6);
    doc.text('Method', 160, yPos + 6);
    yPos += 12; // Adjusted for next row

    // Rows
    doc.setFont('helvetica', 'normal');
    if (paymentsHistory.length > 0) {
      paymentsHistory.forEach(pmt => {
        if (checkPageBreak(10)) {
          yPos += 12;
        }

        const d = formatDate(pmt.created_at || pmt.payment_date);
        const amt = `INR ${(pmt.amount || pmt.payment_amount || 0).toLocaleString()}`;
        const sts = (pmt.status || pmt.payment_status || 'pending').toUpperCase();
        const pln = pmt.plan || pmt.package || '-';
        const mtd = pmt.method || pmt.payment_method || '-';

        doc.text(d, 20, yPos);
        doc.text(amt, 60, yPos);
        doc.text(sts, 90, yPos);
        doc.text(pln, 130, yPos);
        doc.text(mtd, 160, yPos);

        yPos += 8;
      });
    } else {
      doc.text('No payment history available.', 20, yPos);
      yPos += 8;
    }

    // Footer
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    }

    // Save
    doc.save(`Client_Report_${client.businessName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  if (!client) {
    logger.log('Client data not loaded yet - showing loading...');
    return <Typography>Loading...</Typography>;
  }

  logger.log('ClientProfile rendering with Add Attachment button - client:', client.businessName);
  logger.log('Attachment upload modal state:', attachmentUploadOpen);

  return (
    <ProfileContainer>
      <Header>
        <TitleSection>
          <TitleIcon>
            <CalendarTodayIcon fontSize="large" />
          </TitleIcon>
          <Box>
            <Typography variant="h4" fontWeight={700} color="#1f2937">
              {lead?.lead_uid ? `Client ${lead.lead_uid}` : client?.lead_uid ? `Client ${client.lead_uid}` : 'Client Profile'}
            </Typography>
            <Typography variant="body2" color="text.secondary">Manage client details and activities</Typography>
          </Box>
        </TitleSection>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<UploadIcon />}
            onClick={handleGoToGmbProfile}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              borderColor: client?.isConnected ? '#3b82f6' : '#94a3b8',
              color: client?.isConnected ? '#3b82f6' : '#94a3b8',
              '&:hover': {
                borderColor: client?.isConnected ? '#2563eb' : '#94a3b8',
                bgcolor: client?.isConnected ? 'rgba(59, 130, 246, 0.04)' : 'transparent'
              }
            }}
          >
            Go To GMB Profile
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate(`/admin-dashboard/edit-client/${clientId}`)}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
              '&:hover': { background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)' }
            }}
          >
            Edit Profile
          </Button>
        </Box>
      </Header>

      <ProfileCard>
        <DetailsGrid>
          <Box>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#1f2937' }}>Business Information</Typography>
            <DetailItem>
              <DetailLabel>Client ID</DetailLabel>
              <DetailValue>
                <Typography component="span" sx={{ fontFamily: 'monospace', fontWeight: 700, color: '#64748b' }}>
                  {lead?.lead_uid || client?.lead_uid || '—'}
                </Typography>
              </DetailValue>
            </DetailItem>
            <DetailItem><DetailLabel>Business Name</DetailLabel><DetailValue color="primary.main">{client.businessName}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Business Category</DetailLabel><DetailValue>{client.businessCategory}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Contact Number</DetailLabel><DetailValue>{client.contact}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>WhatsApp</DetailLabel><DetailValue>{client.whatsapp}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Email</DetailLabel><DetailValue>{client.email}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Plan</DetailLabel><DetailValue>
              {client.plan ? (
                <SharedPlanChip plan={client.plan} />
              ) : (
                <Chip
                  label="NO PLAN"
                  size="small"
                  variant="outlined"
                  sx={{ fontWeight: 600, fontSize: '11px', color: '#94a3b8', borderColor: '#94a3b8' }}
                />
              )}
            </DetailValue></DetailItem>
            <DetailItem><DetailLabel>Address</DetailLabel><DetailValue>{client.address}</DetailValue></DetailItem>
            {client.website && (
              <DetailItem><DetailLabel>Website</DetailLabel><DetailValue>
                <a href={client.website} target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                  {client.website}
                </a>
              </DetailValue></DetailItem>
            )}
          </Box>
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1f2937' }}>Management Details</Typography>
              <IconButton
                size="small"
                onClick={handleEditMgmtOpen}
                sx={{
                  bgcolor: 'rgba(59, 130, 246, 0.1)',
                  color: '#3b82f6',
                  '&:hover': { bgcolor: 'rgba(59, 130, 246, 0.2)' }
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
            <DetailItem><DetailLabel>Lead Source</DetailLabel><DetailValue>{lead?.lead_source || client.leadSource}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Family Accounts</DetailLabel><DetailValue>{client.familyAccount}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>BDM</DetailLabel><DetailValue>{lead?.bdm_name || client.bdm}</DetailValue></DetailItem>
            <DetailItem><DetailLabel>Welcome Call</DetailLabel><DetailValue sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                label={(lead?.welcome_call || client.welcomeCall === 'Yes') ? 'Completed' : 'Pending'}
                size="small"
                color={(lead?.welcome_call || client.welcomeCall === 'Yes') ? 'success' : 'error'}
                sx={{ fontWeight: 600, fontSize: '11px' }}
              />
              {!(lead?.welcome_call || client.welcomeCall === 'Yes') && (
                <Button
                  size="small"
                  variant="outlined"
                  color="success"
                  onClick={handleWelcomeCallComplete}
                  disabled={updatingWelcomeCall}
                  sx={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    minWidth: 'auto',
                    height: '24px',
                    textTransform: 'none'
                  }}
                >
                  {updatingWelcomeCall ? 'Saving...' : 'Mark Done'}
                </Button>
              )}
            </DetailValue></DetailItem>
            <Box sx={{ mt: 4, p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Profile Health Score</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ flex: 1, height: '8px', bgcolor: '#e2e8f0', borderRadius: '4px', overflow: 'hidden' }}>
                  <Box sx={{ width: `${completionPercentage}%`, height: '100%', background: 'linear-gradient(90deg, #3b82f6, #10b981)' }} />
                </Box>
                <Typography variant="h6" fontWeight={700} color="primary.main">{completionPercentage}%</Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#1f2937' }}>Plan & Renewal</Typography>
            {planDetails.start ? (
              <>
                <DetailItem><DetailLabel>Plan Started</DetailLabel><DetailValue>{formatDate(planDetails.start)}</DetailValue></DetailItem>
                <DetailItem><DetailLabel>Renews On</DetailLabel><DetailValue sx={{ fontWeight: 700, color: planDetails.renewSoon ? 'warning.main' : 'inherit' }}>{formatDate(planDetails.end)}</DetailValue></DetailItem>
                <DetailItem>
                  <DetailLabel>Status</DetailLabel>
                  <DetailValue>
                    {planDetails.isOverdue ? (
                      <Chip label={`Overdue (${Math.abs(planDetails.daysRemaining)} days)`} color="error" size="small" sx={{ fontWeight: 700 }} />
                    ) : planDetails.renewSoon ? (
                      <Chip label={`Renew Soon (${planDetails.daysRemaining} days)`} color="warning" size="small" sx={{ fontWeight: 700 }} />
                    ) : (
                      <Chip label={`${planDetails.daysRemaining} days remaining`} color="success" size="small" sx={{ fontWeight: 700 }} />
                    )}
                  </DetailValue>
                </DetailItem>
              </>
            ) : (
              <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '8px', border: '1px dashed #cbd5e1' }}>
                <Typography variant="body2" color="text.secondary" align="center">No active plan history found.</Typography>
              </Box>
            )}
          </Box>
        </DetailsGrid>
      </ProfileCard>

      <StyledTabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab icon={<CalendarTodayIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Payments" />
        <Tab icon={<ScheduleIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Meeting" />
        <Tab icon={<TrendingUpIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Activity" />
        <Tab icon={<SvgIcon component={LocalCitationIcon} sx={{ fontSize: 18 }} inheritViewBox />} iconPosition="start" label="Citations" />
        <Tab icon={<AttachIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Attachment" />
        <Tab icon={<AssessmentIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Report" />
      </StyledTabs>

      {tabIndex === 0 && (
        <TicketsTableContainer component={Paper}>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700 }}>
              Payment Details
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={async () => {
                  if (!client?.userId && !client?.locationId) return;
                  try {
                    setLoadingPaymentsHistory(true);
                    await ApiService.post('/admin/gmb-account/sync-subscription-from-payments', {
                      user_id: client?.userId,
                      location_id: client?.locationId
                    });
                    setRefreshTrigger(p => p + 1); // Refresh profile data
                    alert('Subscription synced from payments!');
                  } catch (e) {
                    alert('Failed to sync subscription');
                  } finally {
                    setLoadingPaymentsHistory(false);
                  }
                }}
                disabled={(!client?.userId && !client?.locationId) || loadingPaymentsHistory}
                sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600 }}
              >
                Sync Subscription
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon />}
                onClick={handleOpenPaymentEdit}
                disabled={!lead}
                sx={{
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                  boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                }}
              >
                Manage Payment
              </Button>
            </Box>
          </Box>

          {/* Payment Details Section */}
          <Box sx={{ p: 3 }}>

            {/* Detailed Payment Info */}
            <Box sx={{ bgcolor: '#f8fafc', borderRadius: '12px', p: 3, border: '1px solid #e2e8f0' }}>
              <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, color: '#1f2937' }}>
                💳 Payment Information
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
                <DetailItem>
                  <DetailLabel>Payment Date</DetailLabel>
                  <DetailValue>
                    {lead?.payment_date ? new Date(lead.payment_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                  </DetailValue>
                </DetailItem>
                <DetailItem>
                  <DetailLabel>Payment Method</DetailLabel>
                  <DetailValue>
                    {lead?.payment_method ?
                      lead.payment_method === 'online' ? 'Online (UPI/Card)' :
                        lead.payment_method === 'bank_transfer' ? 'Bank Transfer' :
                          lead.payment_method === 'cash' ? 'Cash' :
                            lead.payment_method === 'cheque' ? 'Cheque' : lead.payment_method
                      : '—'}
                  </DetailValue>
                </DetailItem>
                <DetailItem>
                  <DetailLabel>Transaction Reference</DetailLabel>
                  <DetailValue>{lead?.payment_reference || '—'}</DetailValue>
                </DetailItem>
                <DetailItem>
                  <DetailLabel>Package/Plan</DetailLabel>
                  <DetailValue>
                    <Chip
                      label={(lead?.package || client?.plan || 'None').toUpperCase()}
                      size="small"
                      color="primary"
                      sx={{ fontWeight: 600 }}
                    />
                  </DetailValue>
                </DetailItem>
              </Box>
            </Box>

            {!lead && (
              <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                <Typography>No payment information available. Click "Update Payment" to add payment details.</Typography>
              </Box>
            )}

            {/* Payment Ledger / History */}
            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700, mb: 2 }}>
                Payment History (Ledger)
              </Typography>
              <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #e2e8f0', borderRadius: '12px' }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f8fafc' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Method</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Plan</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Reference</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingPaymentsHistory ? (
                      <TableRow><TableCell colSpan={6} align="center">Loading history...</TableCell></TableRow>
                    ) : paymentsHistory.length === 0 ? (
                      <TableRow><TableCell colSpan={6} align="center" sx={{ color: 'text.secondary' }}>No payment history found.</TableCell></TableRow>
                    ) : (
                      paymentsHistory.map((payment, index) => (
                        <TableRow key={payment.id || index} hover>
                          <TableCell>
                            {formatDate(payment.created_at || payment.createdAt || payment.payment_date)}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, color: 'success.main' }}>
                            ₹{(payment.amount || payment.payment_amount || 0).toLocaleString('en-IN')}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={(payment.status || payment.payment_status || 'pending').toUpperCase()}
                              color={(payment.status === 'paid' || payment.payment_status === 'paid') ? 'success' : 'warning'}
                              size="small"
                              sx={{ fontWeight: 700, fontSize: '11px' }}
                            />
                          </TableCell>
                          <TableCell sx={{ textTransform: 'capitalize' }}>
                            {payment.method || payment.payment_method || '-'}
                          </TableCell>
                          <TableCell>
                            {payment.plan || payment.package || '-'}
                          </TableCell>
                          <TableCell sx={{ fontFamily: 'monospace', fontSize: '12px' }}>
                            {payment.order_id || payment.payment_reference || '-'}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </TicketsTableContainer>
      )}



      {tabIndex === 1 && (
        <TicketsTableContainer component={Paper}>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700 }}>
              Meeting Schedule
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
              }}
              onClick={() => setAddMeetingOpen(true)}
            >
              Add Meeting
            </Button>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <Th>Meeting ID</Th>
                <Th>Title & Description</Th>
                <Th>Scheduled Date</Th>
                <Th align="center">Status</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingMeetings ? (
                <StyledTableRow><Td colSpan={4} align="center">Loading meetings...</Td></StyledTableRow>
              ) : meetings.length === 0 ? (
                <StyledTableRow><Td colSpan={4} align="center">No meetings found</Td></StyledTableRow>
              ) : (
                meetings.map(meeting => (
                  <StyledTableRow key={meeting.id}>
                    <Td><Typography fontWeight={700} color="primary.main">{meeting.id}</Typography></Td>
                    <Td>
                      <Typography fontWeight={600} color="#1f2937">{meeting.title}</Typography>
                      <Typography variant="body2" color="#64748b" sx={{ mt: 0.5 }}>
                        {meeting.description}
                      </Typography>
                    </Td>
                    <Td><Typography fontWeight={600} color="#1f2937">{meeting.scheduledDate}</Typography></Td>
                    <Td align="center">
                      <Chip
                        label={meeting.status}
                        color={meeting.status === 'Completed' ? 'success' : 'warning'}
                        size="small"
                        sx={{ fontWeight: 600, fontSize: '11px' }}
                      />
                    </Td>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TicketsTableContainer>
      )}

      {/* Support Tickets tab removed */}

      {tabIndex === 2 && (
        <TicketsTableContainer component={Paper}>
          <Box sx={{ p: 2, background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700 }}>
              Activity History
            </Typography>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <Th>Date & Time</Th>
                <Th>Activity Type</Th>
                <Th>Description</Th>
                <Th>Performed By</Th>
                <Th align="center">Status</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingActivities ? (
                <StyledTableRow><Td colSpan={5} align="center">Loading activities...</Td></StyledTableRow>
              ) : activities.length === 0 ? (
                <StyledTableRow><Td colSpan={5} align="center">No activity history found</Td></StyledTableRow>
              ) : (
                activities.map(activity => {
                  const dateObj = new Date(activity.createdAt || activity.created_at || activity.updatedAt || activity.updated_at);
                  const dateStr = !isNaN(dateObj) ? formatDate(dateObj) : '—';
                  const timeStr = !isNaN(dateObj) ? formatTime(dateObj) : '';

                  // Format description based on current_data if needed
                  let desc = activity.activity_type || 'Activity Logged';

                  switch (activity.activity_type) {
                    case 'Add Leads':
                      desc = 'Lead profile created';
                      break;

                    case 'Welcome Call Completed':
                      const notes = activity.current_data?.notes;
                      desc = notes ? `Welcome Call Done. Notes: ${notes}` : 'Welcome call completed';
                      break;

                    case 'Schedule Meeting':
                      if (activity.current_data?.title) {
                        desc = `Meeting scheduled: ${activity.current_data.title}`;
                      } else {
                        desc = 'Meeting scheduled';
                      }
                      break;

                    case 'Lead Converted to Client':
                      desc = 'Lead converted to paying client';
                      break;

                    case 'Close Deal':
                      const dealData = activity.current_data || {};
                      const dealDetails = [];
                      if (dealData.package_name) dealDetails.push(`Package: ${dealData.package_name}`);
                      if (dealData.amount) dealDetails.push(`Amount: ₹${dealData.amount}`);
                      desc = `Deal closed${dealDetails.length > 0 ? ` - ${dealDetails.join(', ')}` : ''}`;
                      break;

                    case 'Subscription Purchase - Lead Converted to Client':
                      desc = 'Client subscribed and converted from lead';
                      break;

                    case 'New Client from Subscription Purchase':
                      desc = 'New client created from subscription purchase';
                      break;

                    case 'Update Lead Details':
                      const data = activity.current_data || {};
                      const updates = [];

                      // Handle Welcome Call specifically - if it's there, just show that
                      if ('welcome_call' in data && data.welcome_call) {
                        desc = 'Welcome call completed';
                      } else {
                        // Allowlist of fields to display with human-readable labels
                        const fieldMap = {
                          'lead_source': 'Lead Source',
                          'bdm_name': 'BDM',
                          'package': 'Package',
                          'whatsapp': 'WhatsApp Number',
                          'status': 'Status',
                          'business_name': 'Business Name',
                          'contact_person': 'Contact Person',
                          'phone_number': 'Phone Number',
                          'email': 'Email Address',
                          'gst_number': 'GST Number',
                          'website': 'Website',
                          'address_line1': 'Address',
                          'address_line2': 'Address Line 2',
                          'city': 'City',
                          'state': 'State',
                          'zip_code': 'ZIP Code',
                          'country': 'Country',
                          'alt_number': 'Alternate Number',
                          'tags': 'Tags',
                          'type': 'Lead Type',
                          'comment': 'Comments',
                          'is_website_service': 'Website Service',
                          'is_gmb_services': 'GMB Service',
                          'is_smo_services': 'SMO Service',
                          'is_other_services': 'Other Services',
                          'payment_amount': 'Payment Amount',
                          'payment_date': 'Payment Date',
                          'payment_status': 'Payment Status',
                          'payment_method': 'Payment Method',
                          'payment_reference': 'Payment Reference',
                          'payment_type': 'Payment Type',
                          'category': 'Business Category',
                          'first_name': 'First Name',
                          'last_name': 'Last Name',
                          'contact_email': 'Contact Email',
                          'gmb_account_id': 'GMB Account ID',
                          'employee_id': 'Employee ID',
                          'telly_employee_id': 'Telly Team',
                          'bdm_employee_id': 'BDM Employee'
                        };

                        Object.keys(data).forEach(key => {
                          if (fieldMap[key] && data[key] !== undefined && data[key] !== null && data[key] !== '') {
                            if (key === 'lead_source' || key === 'bdm_name' || key === 'package' || key === 'status' || key === 'type' || key === 'payment_status' || key === 'payment_method' || key === 'payment_type' || key === 'category') {
                              updates.push(`${fieldMap[key]}: ${data[key]}`);
                            } else if (typeof data[key] === 'boolean') {
                              updates.push(`${fieldMap[key]}: ${data[key] ? 'Enabled' : 'Disabled'}`);
                            } else if (key === 'payment_amount') {
                              updates.push(`${fieldMap[key]}: ₹${data[key]}`);
                            } else if (key === 'payment_date') {
                              updates.push(`${fieldMap[key]}: ${formatDate(data[key])}`);
                            } else {
                              updates.push(`${fieldMap[key]} updated`);
                            }
                          }
                        });

                        if (updates.length > 0) {
                          desc = `Updated: ${updates.join(', ')}`;
                        } else {
                          desc = 'Client details updated';
                        }
                      }
                      break;

                    default:
                      // For any unhandled activity types, try to make them more readable
                      if (activity.activity === 'Meeting' && activity.current_data?.title) {
                        desc = `Meeting: ${activity.current_data.title}`;
                      } else {
                        // Convert technical names to readable format
                        desc = activity.activity_type
                          .replace(/([A-Z])/g, ' $1') // Add spaces before capital letters
                          .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
                          .trim();
                      }
                      break;
                  }

                  return (
                    <StyledTableRow key={activity.id}>
                      <Td>
                        <Typography fontWeight={600} fontSize="14px">{dateStr}</Typography>
                        <Typography variant="caption" color="text.secondary">{timeStr}</Typography>
                      </Td>
                      <Td><Typography fontWeight={700} color="#1f2937" fontSize="14px">{activity.activity === 'Lead' ? 'Client' : activity.activity}</Typography></Td>
                      <Td><Typography variant="body2" color="#64748b">{desc}</Typography></Td>
                      <Td><Typography fontWeight={600} fontSize="14px">{activity.addedby?.full_name || 'System'}</Typography></Td>
                      <Td align="center">
                        <Chip
                          label={activity.action || 'Log'}
                          size="small"
                          color="default"
                          sx={{ fontWeight: 600, fontSize: '10px' }}
                        />
                      </Td>
                    </StyledTableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TicketsTableContainer>
      )}

      {tabIndex === 3 && (
        <TicketsTableContainer component={Paper} sx={{ mb: 4 }}>
          <Box sx={{ p: 2, background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700 }}>
              Citations
            </Typography>
            <Typography variant="body2" color="text.secondary">Directory listings for {client?.businessName}</Typography>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <Th>Directory</Th>
                <Th>Business Name</Th>
                <Th>Address</Th>
                <Th>Phone Number</Th>
                <Th align="center">Actions</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {citations.map((citation, index) => (
                <StyledTableRow key={index}>
                  <Td sx={{ minWidth: 150 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      value={citation.directory}
                      onChange={(e) => handleCitationChange(index, 'directory', e.target.value)}
                      placeholder="Directory Name"
                      InputProps={{ disableUnderline: true, sx: { fontSize: '14px', fontWeight: 600 } }}
                    />
                  </Td>
                  <Td sx={{ minWidth: 180 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      value={citation.businessName}
                      onChange={(e) => handleCitationChange(index, 'businessName', e.target.value)}
                      placeholder="Business Name"
                      InputProps={{ disableUnderline: true, sx: { fontSize: '13px' } }}
                    />
                  </Td>
                  <Td sx={{ minWidth: 220 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      value={citation.address}
                      onChange={(e) => handleCitationChange(index, 'address', e.target.value)}
                      placeholder="Address"
                      InputProps={{ disableUnderline: true, sx: { fontSize: '13px' } }}
                    />
                  </Td>
                  <Td sx={{ minWidth: 140 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      value={citation.phone}
                      onChange={(e) => handleCitationChange(index, 'phone', e.target.value)}
                      placeholder="Phone"
                      InputProps={{ disableUnderline: true, sx: { fontSize: '13px' } }}
                    />
                  </Td>
                  <Td align="center">
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<SaveIcon sx={{ fontSize: '16px !important' }} />}
                      onClick={() => handleSaveCitationRow(index)}
                      disabled={savingCitations}
                      sx={{
                        borderRadius: '6px',
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '12px',
                        py: 0.5,
                        px: 2,
                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                        boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)',
                        '&:hover': {
                          boxShadow: '0 4px 8px rgba(59, 130, 246, 0.3)',
                        }
                      }}
                    >
                      {savingCitations ? 'Saving...' : 'Save'}
                    </Button>
                  </Td>
                </StyledTableRow>
              ))}
              <StyledTableRow>
                <Td colSpan={5} align="center" sx={{ py: 1 }}>
                  <Button
                    startIcon={<AddCircleIcon />}
                    onClick={handleAddCitationRow}
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    Add More Citation
                  </Button>
                </Td>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TicketsTableContainer>
      )}

      {tabIndex === 4 && (
        <TicketsTableContainer component={Paper} sx={{ mb: 4 }}>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e2e8f0' }}>
            <Typography variant="h6" sx={{ color: '#1f2937', fontWeight: 700 }}>
              Attachments ({mockAttachments.length})
            </Typography>
            <Button
              variant="contained"
              startIcon={<UploadIcon />}
              onClick={handleAttachmentUploadOpen}
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
              }}
            >
              Add Attachment
            </Button>
          </Box>
          <Table>
            <TableHead>
              <TableRow>
                <Th>File Name</Th>
                <Th>Type</Th>
                <Th>Size & Date</Th>
                <Th>Uploaded By</Th>
                <Th>Description</Th>
                <Th align="center">Actions</Th>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockAttachments.map(attachment => (
                <StyledTableRow key={attachment.id}>
                  <Td>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{
                        p: 1,
                        borderRadius: '8px',
                        bgcolor: attachment.fileType === 'PDF' ? '#fee2e2' : attachment.fileType === 'JPG' ? '#dcfce7' : '#fef3c7',
                        display: 'flex'
                      }}>
                        {attachment.fileType === 'PDF' && <PdfIcon sx={{ color: '#ef4444', fontSize: 20 }} />}
                        {attachment.fileType === 'JPG' && <ImageIcon sx={{ color: '#22c55e', fontSize: 20 }} />}
                        {attachment.fileType === 'ZIP' && <ArchiveIcon sx={{ color: '#f59e0b', fontSize: 20 }} />}
                        {(!attachment.fileType || ['PDF', 'JPG', 'ZIP'].indexOf(attachment.fileType) === -1) && <FileIcon sx={{ color: '#3b82f6', fontSize: 20 }} />}
                      </Box>
                      <Typography fontWeight={700} color="#1f2937">{attachment.fileName}</Typography>
                    </Box>
                  </Td>
                  <Td>
                    <Chip
                      label={attachment.fileType}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        fontSize: '10px',
                        bgcolor: attachment.fileType === 'PDF' ? '#fee2e2' : attachment.fileType === 'JPG' ? '#dcfce7' : '#fef3c7',
                        color: attachment.fileType === 'PDF' ? '#ef4444' : attachment.fileType === 'JPG' ? '#22c55e' : '#f59e0b'
                      }}
                    />
                  </Td>
                  <Td>
                    <Typography fontWeight={600} fontSize="13px">{attachment.fileSize}</Typography>
                    <Typography variant="caption" color="text.secondary">{attachment.uploadedDate}</Typography>
                  </Td>
                  <Td><Typography fontWeight={600} fontSize="14px">{attachment.uploadedBy}</Typography></Td>
                  <Td>
                    <Typography variant="body2" color="#64748b" sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {attachment.description}
                    </Typography>
                  </Td>
                  <Td align="center">
                    <IconButton
                      size="small"
                      onClick={(e) => handleAttachmentMenuClick(e, attachment)}
                      sx={{ bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </Td>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TicketsTableContainer>
      )}



      {tabIndex === 5 && (
        <TicketsTableContainer component={Paper} sx={{ mb: 4, p: 4 }}>
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#1f2937', mb: 1 }}>
              Client Profile Report
            </Typography>
            <Typography variant="body1" color="text.secondary">
              View summary and download the comprehensive PDF report for {client?.businessName}.
            </Typography>
          </Box>

          <Grid container spacing={4} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', height: '100%' }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#3b82f6' }}>Business & Management</Typography>
                <Stack spacing={1.5}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Business Name</Typography>
                    <Typography variant="body2" fontWeight={600}>{client?.businessName}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Plan</Typography>
                    <Typography variant="body2" fontWeight={600}>{client?.plan ? client.plan.toUpperCase() : 'NO PLAN'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Lead Source</Typography>
                    <Typography variant="body2" fontWeight={600}>{lead?.lead_source || client.leadSource}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>BDM</Typography>
                    <Typography variant="body2" fontWeight={600}>{lead?.bdm_name || client.bdm}</Typography>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', height: '100%' }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#3b82f6' }}>Financial Status</Typography>
                <Stack spacing={1.5}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Payment Status</Typography>
                    <Chip
                      label={(lead?.payment_status || 'pending').toUpperCase()}
                      color={lead?.payment_status === 'paid' ? 'success' : 'warning'}
                      size="small"
                      sx={{ fontWeight: 700, fontSize: '10px', height: '20px' }}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Plan Status</Typography>
                    {planDetails.start ? (
                      <Chip
                        label={planDetails.renewSoon ? 'Renew Soon' : 'Active'}
                        color={planDetails.renewSoon ? 'warning' : 'success'}
                        size="small"
                        sx={{ fontWeight: 700, fontSize: '10px', height: '20px' }}
                      />
                    ) : <Typography variant="caption">N/A</Typography>}
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>Total Transactions</Typography>
                    <Typography variant="body2" fontWeight={600}>{paymentsHistory.length}</Typography>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>


        </TicketsTableContainer>
      )}

      {/* Add New Meeting Dialog */}
      <Dialog open={addMeetingOpen} onClose={() => setAddMeetingOpen(false)} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #eaecef', pb: 1 }}>
            <Typography variant="h6">Add New Meeting</Typography>
            <IconButton onClick={() => setAddMeetingOpen(false)} sx={{ border: '2px solid', borderColor: 'error.main', color: 'error.main', borderRadius: '50%' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 }, px: 3 }}>
          <Stack spacing={2.5} sx={{ mt: 1 }}>
            <TextField
              required
              fullWidth
              label="Title"
              variant="outlined"
              size="small"
              value={newMeeting.title}
              onChange={handleNewMeetingChange('title')}
            />
            <TextField
              required
              fullWidth
              type="text"
              label="Schedule Date"
              placeholder="dd-mm-yy"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              value={newMeeting.date}
              onChange={handleNewMeetingChange('date')}
              onFocus={(e) => {
                e.target.type = 'date';
              }}
              onBlur={(e) => { if (!e.target.value) e.target.type = 'text'; }}
              inputMode="none"
              InputProps={{
                endAdornment: (
                  <IconButton
                    size="small"
                    onClick={(ev) => {
                      const input = ev.currentTarget.closest('div')?.querySelector('input');
                      if (input) {
                        input.type = 'date';
                        if (typeof input.showPicker === 'function') {
                          input.showPicker();
                        } else {
                          input.click();
                        }
                      }
                    }}
                  >
                    <CalendarTodayIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )
              }}
            />
            <TextField
              required
              fullWidth
              label="Schedule Time"
              type="time"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              value={newMeeting.time}
              onChange={handleNewMeetingChange('time')}
            />
            <TextField
              required
              fullWidth
              label="Department"
              variant="outlined"
              size="small"
              value={newMeeting.department}
              onChange={handleNewMeetingChange('department')}
            />
            <TextField
              fullWidth
              label="Description (Optional)"
              multiline
              rows={3}
              variant="outlined"
              size="small"
              value={newMeeting.description}
              onChange={handleNewMeetingChange('description')}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={() => setAddMeetingOpen(false)} sx={{ textTransform: 'none', fontWeight: 600 }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAddMeetingSubmit}
            disabled={!newMeeting.title || !newMeeting.date || !newMeeting.department || !newMeeting.time}
            sx={{
              borderRadius: '10px',
              px: 5,
              textTransform: 'none',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
              '&:hover': { background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)' }
            }}
          >
            Add Meeting
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={attachmentUploadOpen}
        onClose={handleAttachmentUploadClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <UploadIcon />
            <Typography variant="h6">Upload New Attachment</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Upload documents, images, or other files related to this client.
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  File Upload
                </Typography>
                <Box
                  sx={{
                    border: '2px dashed',
                    borderColor: 'primary.main',
                    borderRadius: '8px',
                    p: 4,
                    textAlign: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#f8f9fa',
                    '&:hover': {
                      backgroundColor: '#e3f2fd',
                    }
                  }}
                >
                  <UploadIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" color="primary.main">
                    Drop files here or click to browse
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Supports: PDF, JPG, PNG, DOC, DOCX, ZIP (Max: 25MB)
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{ mt: 2 }}
                    component="label"
                  >
                    Choose Files
                    <input
                      type="file"
                      multiple
                      hidden
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.zip"
                    />
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Purpose
                </Typography>
                <textarea
                  placeholder="Enter a description for the uploaded files..."
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ borderTop: '1px solid #eaecef', px: 3, py: 2.5, gap: 2 }}>
          <Button
            variant="outlined"
            onClick={handleAttachmentUploadClose}
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, px: 4 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              logger.log('Upload attachment clicked');
              handleAttachmentUploadClose();
            }}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              px: 5,
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
              '&:hover': { background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)' }
            }}
          >
            Upload Files
          </Button>
        </DialogActions>
      </Dialog>

      {/* Attachment Viewer Modal */}
      <Dialog
        open={attachmentViewOpen}
        onClose={() => {
          handleAttachmentViewClose();
          setAttachmentViewOpen(false);
        }}
        maxWidth="md"
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {selectedAttachment?.fileType === 'PDF' && <PdfIcon color="error" />}
              {selectedAttachment?.fileType === 'JPG' && <ImageIcon color="success" />}
              {selectedAttachment?.fileType === 'ZIP' && <ArchiveIcon color="warning" />}
              {(!selectedAttachment?.fileType || ['PDF', 'JPG', 'ZIP'].indexOf(selectedAttachment?.fileType) === -1) && <FileIcon color="primary" />}
              <Typography variant="h6">{selectedAttachment?.fileName}</Typography>
            </Box>
            <IconButton onClick={handleAttachmentViewClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              <strong>Description:</strong> {selectedAttachment?.description}
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              <strong>Size:</strong> {selectedAttachment?.fileSize} • <strong>Uploaded:</strong> {selectedAttachment?.uploadedDate} • <strong>By:</strong> {selectedAttachment?.uploadedBy}
            </Typography>

            <Box sx={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              p: 4,
              textAlign: 'center',
              backgroundColor: '#f8f9fa',
              minHeight: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {selectedAttachment?.fileType === 'PDF' && (
                <Box>
                  <PdfIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                  <Typography variant="h6" color="primary.main">
                    PDF Document
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    This PDF document can be viewed or downloaded using the buttons below.
                  </Typography>
                </Box>
              )}

              {selectedAttachment?.fileType === 'JPG' && (
                <Box>
                  <ImageIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                  <Typography variant="h6" color="primary.main">
                    Image File
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    This image file can be viewed or downloaded using the buttons below.
                  </Typography>
                </Box>
              )}

              {selectedAttachment?.fileType === 'ZIP' && (
                <Box>
                  <ArchiveIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
                  <Typography variant="h6" color="primary.main">
                    Archive File
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    This archive file can be downloaded using the button below.
                  </Typography>
                </Box>
              )}

              {(!selectedAttachment?.fileType || ['PDF', 'JPG', 'ZIP'].indexOf(selectedAttachment?.fileType) === -1) && (
                <Box>
                  <FileIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" color="primary.main">
                    Document File
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    This document can be downloaded using the button below.
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAttachmentViewClose}>
            Close
          </Button>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={() => {
              logger.log('Downloading attachment:', selectedAttachment?.fileName);
              // In a real app, you would trigger the download here
              // window.open(selectedAttachment?.downloadUrl, '_blank');
              handleAttachmentViewClose();
            }}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Management Details Dialog */}
      <Dialog
        open={editMgmtOpen}
        onClose={() => setEditMgmtOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #eaecef', pb: 1 }}>
            <Typography variant="h6">Edit Management Details</Typography>
            <IconButton onClick={() => setEditMgmtOpen(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <TextField
              label="Lead Source"
              fullWidth
              size="small"
              value={editMgmtData.leadSource}
              onChange={(e) => setEditMgmtData(prev => ({ ...prev, leadSource: e.target.value }))}
            />

            <FormControl fullWidth size="small">
              <InputLabel>Telly Team (Caller)</InputLabel>
              <Select
                value={editMgmtData.tellyId}
                label="Telly Team (Caller)"
                onChange={(e) => setEditMgmtData(prev => ({ ...prev, tellyId: e.target.value }))}
              >
                <MenuItem value=""><em>None</em></MenuItem>
                {employees?.map(emp => (
                  <MenuItem key={emp.id} value={emp.id}>
                    {emp.first_name} {emp.last_name} ({emp.role?.role_name || 'Employee'})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth size="small">
              <InputLabel>BDM (Sales)</InputLabel>
              <Select
                value={editMgmtData.bdmId}
                label="BDM (Sales)"
                onChange={(e) => setEditMgmtData(prev => ({ ...prev, bdmId: e.target.value }))}
              >
                <MenuItem value=""><em>None</em></MenuItem>
                {employees?.map(emp => (
                  <MenuItem key={emp.id} value={emp.id}>
                    {emp.first_name} {emp.last_name} ({emp.role?.role_name || 'Employee'})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ borderTop: '1px solid #eaecef', px: 3, py: 2.5 }}>
          <Button onClick={() => setEditMgmtOpen(false)} sx={{ borderRadius: '8px' }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleEditMgmtSubmit}
            disabled={updatingMgmt}
            sx={{ borderRadius: '8px', boxShadow: 'none' }}
          >
            {updatingMgmt ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Schedule Attachment Dialog */}
      <Dialog
        open={scheduleDialogOpen}
        onClose={handleScheduleAttachmentClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ScheduleIcon color="primary" />
              <Typography variant="h6">Schedule Attachment</Typography>
            </Box>
            <IconButton onClick={handleScheduleAttachmentClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Schedule this attachment for review or follow-up actions.
            </Typography>

            {selectedAttachment && (
              <Box sx={{ mb: 3, p: 2, backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Selected Attachment:
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {selectedAttachment.fileType === 'PDF' && <PdfIcon color="error" />}
                  {selectedAttachment.fileType === 'JPG' && <ImageIcon color="success" />}
                  {selectedAttachment.fileType === 'ZIP' && <ArchiveIcon color="warning" />}
                  {(!selectedAttachment.fileType || ['PDF', 'JPG', 'ZIP'].indexOf(selectedAttachment.fileType) === -1) && <FileIcon color="primary" />}
                  <Typography fontWeight={600}>{selectedAttachment.fileName}</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  {selectedAttachment.description}
                </Typography>
              </Box>
            )}

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Schedule Type *
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>Schedule Type</InputLabel>
                  <Select label="Schedule Type" defaultValue="review">
                    <MenuItem value="review">Review</MenuItem>
                    <MenuItem value="follow-up">Follow-up</MenuItem>
                    <MenuItem value="approval">Approval</MenuItem>
                    <MenuItem value="meeting">Meeting</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Priority *
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>Priority</InputLabel>
                  <Select label="Priority" defaultValue="medium">
                    <MenuItem value="low">Low</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="high">High</MenuItem>
                    <MenuItem value="urgent">Urgent</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Due Date *
                </Typography>
                <TextField
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  defaultValue={new Date().toISOString().split('T')[0]}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Due Time
                </Typography>
                <TextField
                  type="time"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  defaultValue="09:00"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Assign To
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>Assignee</InputLabel>
                  <Select label="Assignee" defaultValue="current-user">
                    <MenuItem value="current-user">Current User</MenuItem>
                    <MenuItem value="manager">Manager</MenuItem>
                    <MenuItem value="team-lead">Team Lead</MenuItem>
                    <MenuItem value="admin">Admin</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Notes (Optional)
                </Typography>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  placeholder="Add any additional notes or instructions..."
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  Notification Settings
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Email notification"
                  />
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="SMS notification"
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Push notification"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleScheduleAttachmentClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              logger.log('Scheduling attachment:', selectedAttachment?.fileName);
              // In a real app, you would save the schedule to the backend
              handleScheduleAttachmentClose();
            }}
          >
            Schedule Attachment
          </Button>
        </DialogActions>
      </Dialog>

      {/* Payment Edit Dialog */}
      <Dialog open={editPaymentOpen} onClose={() => setEditPaymentOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: 'white', fontWeight: 700 }}>
          💳 Update Payment Details
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>Package / Plan</InputLabel>
              <Select
                name="package"
                value={paymentData.package || ''}
                onChange={handlePaymentFormChange}
                label="Package / Plan"
              >
                <MenuItem value="">Select Plan</MenuItem>
                {PLAN_SELECT_OPTIONS.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Client Type (Payment Schedule)</InputLabel>
              <Select
                name="payment_type"
                value={paymentData.payment_type}
                onChange={handlePaymentFormChange}
                label="Client Type (Payment Schedule)"
              >
                <MenuItem value="one_shot">{PLAN_TYPE_LABELS.one_shot}</MenuItem>
                <MenuItem value="emi">{PLAN_TYPE_LABELS.emi}</MenuItem>
              </Select>
            </FormControl>
            <Box sx={{ p: 2, bgcolor: '#f0f9ff', borderRadius: '8px', border: '1px solid #93c5fd' }}>
              <Typography variant="caption" color="text.secondary">
                {planAutoText}
              </Typography>
            </Box>
            <TextField
              fullWidth
              label="Payment Date"
              name="payment_date"
              value={paymentData.payment_date}
              onChange={handlePaymentFormChange}
              type="date"
              InputLabelProps={{ shrink: true }}
            />
            <FormControl fullWidth>
              <InputLabel>Payment Status</InputLabel>
              <Select
                name="payment_status"
                value={paymentData.payment_status}
                onChange={handlePaymentFormChange}
                label="Payment Status"
              >
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
                <MenuItem value="partial">Partial</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Payment Method</InputLabel>
              <Select
                name="payment_method"
                value={paymentData.payment_method}
                onChange={handlePaymentFormChange}
                label="Payment Method"
              >
                <MenuItem value="">Select Method</MenuItem>
                <MenuItem value="online">Online (UPI/Card)</MenuItem>
                <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                <MenuItem value="cash">Cash</MenuItem>
                <MenuItem value="cheque">Cheque</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Transaction Reference / Receipt No."
              name="payment_reference"
              value={paymentData.payment_reference}
              onChange={handlePaymentFormChange}
              placeholder="e.g., TXN123456789"
            />
            <TextField
              fullWidth
              label="Payment Amount (₹)"
              name="payment_amount"
              value={paymentData.payment_amount}
              onChange={handlePaymentFormChange}
              type="number"
              placeholder="e.g., 15000"
              helperText="Auto-filled from the selected plan unless you override it."
              inputProps={{ min: 0 }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setEditPaymentOpen(false)} disabled={updatingPayment}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handlePaymentSubmit}
            disabled={updatingPayment}
            sx={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}
          >
            {updatingPayment ? 'Saving...' : 'Save Payment'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Attachment Actions Menu */}
      <Menu
        anchorEl={attachmentMenuAnchor}
        open={Boolean(attachmentMenuAnchor)}
        onClose={handleAttachmentMenuClose}
      >
        <MenuItem onClick={() => handleAttachmentAction('view', selectedAttachment)}>
          <ListItemIcon>
            <ViewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAttachmentAction('schedule', selectedAttachment)}>
          <ListItemIcon>
            <ScheduleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Schedule</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAttachmentAction('delete', selectedAttachment)} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>



    </ProfileContainer>
  );
};

export default ClientProfile;



